<template>
  <div>
    <topbar />
    <div class="wrapper gb-wrapper">
      <div class="wrapper-in">
        <header1 />
        <div class="content gb-final">
          <commonSidebar />
          <mainContent />
        </div>
        <commonFooter />
      </div>
      <vueToTop />
    </div>
  </div>
</template>
<script>
import '../assets/css/final.css'
import topbar from '../components/common/topbar'
import header1 from '../components/common/header1'
import commonSidebar from '../components/common/side'
import mainContent from '../components/intro/Content'
import commonFooter from '../components/common/footer'
import vueToTop from 'vue-totop'
export default {
  // mounted: function () {
  //   console.log(this.type)
  // },

  components: { topbar, header1, commonFooter, commonSidebar, mainContent, vueToTop }
}
</script>



// WEBPACK FOOTER //
// src/views/introContent.vue